import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Collapsible from 'react-collapsible';
import { propArrayNum, propArrayShape, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../helpers/use/useHook';
import SearchFilterItems from './SearchFilterItems';
const SearchFilterCollapsible = (props) => {
    const { inputItems, inputName, label, onChange, viewItems } = props;
    const { boolState: isShow, changeToggle: toggleCollapsible } = useBoolState(true);
    return (_jsxs("div", Object.assign({ className: 'search_list_filter_collapse' }, { children: [_jsxs("h5", Object.assign({ className: 'pointer', onClick: toggleCollapsible, role: 'presentation' }, { children: [_jsx("span", { children: label }), _jsx("i", Object.assign({ className: 'material-icons' }, { children: isShow ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }))] })), _jsx(Collapsible, Object.assign({ open: isShow, transitionTime: 250 }, { children: _jsx(SearchFilterItems, { inputItems: inputItems, inputName: inputName, onChangeInputFilter: onChange, viewItems: viewItems }) }))] })));
};
SearchFilterCollapsible.propTypes = {
    inputItems: propArrayNum().isRequired,
    inputName: propStr().isRequired,
    label: propStr().isRequired,
    onChange: propFunc().isRequired,
    viewItems: propArrayShape().isRequired,
};
export default SearchFilterCollapsible;
